import React, { useState } from 'react';

import { useContextSelector } from 'use-context-selector';

import { PlatformContext } from '../../contexts/PlatformContext';
import { maskPhone } from '../../utils/masks';
import { capitalize } from '../../utils/formatters';

import ContainerPage from '../../components/ContainerPage';

const UnidadeIbirapueraImg =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/unidade-jardins/1x.jpeg';
const PinRoundedImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pin-rouded.svg';
const ClockImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/clock-blue.svg';
const CloseIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/times-gray.svg';
const EmailImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/email-rounded.svg';
const PhoneImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/phone-blue.svg';
const FaceRoundedImg =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/face-rounded.svg';
const ChevronImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-down.svg';

import { Content, Title, Topic, TopicText, InfoWrapper, Wrapper, TagList, CloseButton, Sector } from './styles';
import WorkHours from './components/ServiceHours';
import { unitWorkDaysString, unitWorkHoursString } from '../../utils/dates';

export const UnitAuxiliaryInfo = () => {
  const { selectedUnit, setIsSchedulerOpen } = useContextSelector(PlatformContext, state => state);

  const [collapseOpened, setCollapseOpened] = useState<string>('');

  const phoneList = selectedUnit?.contacts.filter(contact => contact.type !== 'E-mail');

  const emailList = selectedUnit?.contacts.filter(contact => contact.type === 'E-mail');

  const validateSectors = () => {
    return selectedUnit?.locations?.find(locations => locations.description);
  };

  const openingHours = selectedUnit ? unitWorkHoursString(selectedUnit.workHours) : [];

  return (
    <ContainerPage standardSpacing>
      <Content>
        <img src={selectedUnit?.img_url || UnidadeIbirapueraImg} alt={selectedUnit?.name} />

        <InfoWrapper>
          <Wrapper>
            <Title>{capitalize(selectedUnit ? selectedUnit.name : '')}</Title>
            <CloseButton onClick={() => setIsSchedulerOpen(false)}>
              <img src={CloseIcon} alt="close" />
            </CloseButton>
          </Wrapper>

          <Topic>
            <img src={PinRoundedImg} alt="location" />
            <TopicText>
              <p>Endereço</p>
              <p>
                <span>
                  {selectedUnit?.address.name}, {selectedUnit?.address.number}
                </span>
                <br />
                <span>
                  {selectedUnit?.address.neighborhood}, {selectedUnit?.address.city} - {selectedUnit?.address.state}
                </span>
              </p>
            </TopicText>
          </Topic>

          {selectedUnit?.locations.length && selectedUnit.workHours && validateSectors() ? (
            <Topic>
              <img src={ClockImg} alt="clock" />
              <TopicText>
                <p>Horário de atendimento</p>
                {!selectedUnit.locations.some(item => item.service_hours) && (
                  <p>
                    <span>{openingHours.length > 0 && openingHours[0]}</span>
                    {openingHours.length > 1 &&
                      openingHours.slice(1, openingHours.length).map((text, index) => (
                        <span key={index}>
                          <br />
                          {text}
                        </span>
                      ))}
                  </p>
                )}
                {selectedUnit?.locations.map(location => {
                  if (location.service_hours) {
                    if (collapseOpened === location.id) {
                      return (
                        <Sector>
                          {location.service_hours && (
                            <>
                              <div id="active" onClick={() => setCollapseOpened('')}>
                                <p>{location.description}</p>
                                <img src={ChevronImg} alt="chevron" />
                              </div>
                              <WorkHours service_hours={location.service_hours} />
                            </>
                          )}
                        </Sector>
                      );
                    } else {
                      return (
                        <Sector>
                          <div onClick={() => setCollapseOpened(location.id)}>
                            <p>{location.description}</p>
                            <img src={ChevronImg} alt="chevron" />
                          </div>
                        </Sector>
                      );
                    }
                  }
                })}
              </TopicText>
            </Topic>
          ) : null}

          {phoneList && phoneList.length ? (
            <Topic>
              <img src={PhoneImg} alt="phone" />
              <TopicText>
                <p>Telefones</p>
                {phoneList.map(phone => {
                  return (
                    <p>
                      <span>{phone.type}</span>
                      <br />
                      <a href={`tel:+55${phone.value}`}>+55 {maskPhone(phone.value)}</a>
                    </p>
                  );
                })}
              </TopicText>
            </Topic>
          ) : null}

          {emailList && emailList.length ? (
            <Topic>
              <img src={EmailImg} alt="email" />
              <TopicText>
                <p>Emails</p>
                {emailList.map(email => {
                  return (
                    <p>
                      <span>{email.type}</span>
                      <br />
                      <a href={`mailto:${email.value}`}>{email.value}</a>
                    </p>
                  );
                })}
              </TopicText>
            </Topic>
          ) : null}

          {selectedUnit?.facilities.length ? (
            <Topic>
              <img src={FaceRoundedImg} alt="facilities" />
              <TopicText>
                <p>Facilidades</p>
                <TagList>
                  {selectedUnit?.facilities.map(facility => {
                    return <li>{capitalize(facility.name)}</li>;
                  })}
                </TagList>
              </TopicText>
            </Topic>
          ) : null}
        </InfoWrapper>
      </Content>
    </ContainerPage>
  );
};
